@if (isBackOffice) {
  <lib-linked-operations-cell [operation]="operation"></lib-linked-operations-cell
    >
    }{{ displayName ?? '-' }}
